import React from "react";
import { TextAreaInput } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import { useChannelInfoOptions } from "./ChannelContext";

const EditChannelBannerMessage = () => {
  const {
    channelBannerMessage,
    handleChannelInfoChange,
  } = useChannelInfoOptions();
  const { t } = useI18n(["common"]);

  const setChannelBannerMEssage = e => {
    handleChannelInfoChange({ channelBannerMessage: e.target.value });
  };

  return (
    <TextAreaInput
      label={t("common:banner_message")}
      name="bannerMessage"
      size={"medium"}
      placeholder={t("common:enter_with_label", {
        label: t("common:banner_message"),
      })}
      value={channelBannerMessage}
      onChange={setChannelBannerMEssage}
      maxRows={3}
      dsVersion="2.0"
    />
  );
};

export default EditChannelBannerMessage;
